import styled from 'styled-components'

export default styled.div`
  flex: 0 0 100px;
  display: -ms-flexbox;
  -ms-flexbox: 0 0 100px;
  height: 114px;
  margin: 4px 10px 3px 0;
  overflow: hidden;
  position: relative;
  width: 100px;
`
